import { render } from "./RatingCard.vue?vue&type=template&id=70d64c24"
import script from "./RatingCard.vue?vue&type=script&lang=js"
export * from "./RatingCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__